/* "Look inside" reader.
   The pages are heavy scans, so nothing loads until the reader is opened;
   after that the browser's own lazy loading handles the rest of the stack. */
(function () {
  var CLOSE =
    '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.94 15.47 1.47a.75.75 0 1 1 1.06 1.06L10.06 9l6.47 6.47a.75.75 0 1 1-1.06 1.06L9 10.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L7.94 9 1.47 2.53A.75.75 0 0 1 2.53 1.47z" fill="currentColor"/></svg>';

  var box, headingEl, countEl, pagesEl, footEl;
  var lastFocus = null;
  var built = false;

  function build() {
    box = document.createElement('div');
    box.className = 'cp-reader';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Book preview');
    box.innerHTML =
      '<div class="cp-reader__card">' +
      '<div class="cp-reader__head">' +
      '<h2 class="cp-reader__heading"></h2>' +
      '<span class="cp-reader__count"></span>' +
      '<button class="cp-reader__close" type="button" aria-label="Close preview">' + CLOSE + '</button>' +
      '</div>' +
      '<div class="cp-reader__pages"></div>' +
      '<p class="cp-reader__foot"></p>' +
      '</div>';
    document.body.appendChild(box);

    headingEl = box.querySelector('.cp-reader__heading');
    countEl = box.querySelector('.cp-reader__count');
    pagesEl = box.querySelector('.cp-reader__pages');
    footEl = box.querySelector('.cp-reader__foot');

    box.querySelector('.cp-reader__close').addEventListener('click', close);
    // Clicking the scrim closes; clicking the card must not.
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', onKey);
    built = true;
  }

  function onKey(e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = box.querySelectorAll('button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function open(data, trigger) {
    if (!built) build();
    lastFocus = trigger || document.activeElement;

    headingEl.textContent = data.heading || 'Preview';
    countEl.textContent = data.pages.length + (data.pages.length === 1 ? ' page' : ' pages');
    footEl.textContent = data.note || '';
    footEl.hidden = !data.note;

    pagesEl.innerHTML = '';
    data.pages.forEach(function (src, i) {
      var img = document.createElement('img');
      img.className = 'cp-reader__page';
      // The first page is what the reader sees immediately; the rest can wait.
      img.loading = i === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.alt = 'Page ' + (i + 1) + ' of the preview';
      img.src = src;
      pagesEl.appendChild(img);
    });
    pagesEl.scrollTop = 0;

    box.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    box.querySelector('.cp-reader__close').focus();
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    // Drop the decoded pages so a second open starts clean and memory is freed.
    if (pagesEl) pagesEl.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-chapter-preview]').forEach(function (el) {
      if (el.dataset.cpBound) return;
      el.dataset.cpBound = '1';

      var script = el.querySelector('.chapter-preview__data');
      var trigger = el.querySelector('.chapter-preview__trigger');
      if (!script || !trigger) return;

      var data;
      try { data = JSON.parse(script.textContent); } catch (err) { return; }
      if (!data || !data.pages || !data.pages.length) return;

      trigger.addEventListener('click', function () { open(data, trigger); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
